import React from "react";

const Pagination = ({ currentPage, totalPages, paginate }) => {
  return (
    <div className="d-flex justify-content-center mt-2">
      <nav aria-label="Page navigation">
        <ul className="pagination">
          {currentPage > 1 && (
            <li className="page-item">
              <button
                className="page-link"
                onClick={() => paginate(currentPage - 1)}
              >
                Previous
              </button>
            </li>
          )}

          <li className={`page-item ${currentPage === 1 ? "active" : ""}`}>
            <button className="page-link" onClick={() => paginate(1)}>
              1
            </button>
          </li>

          {currentPage > 3 && (
            <li className="page-item">
              <span className="page-link">...</span>
            </li>
          )}

          {currentPage > 2 && (
            <li className="page-item">
              <button
                className="page-link"
                onClick={() => paginate(currentPage - 1)}
              >
                {currentPage - 1}
              </button>
            </li>
          )}

          {currentPage > 1 && currentPage < totalPages && (
            <li className="page-item active">
              <button
                className="page-link"
                onClick={() => paginate(currentPage)}
              >
                {currentPage}
              </button>
            </li>
          )}

          {currentPage < totalPages - 1 && (
            <li className="page-item">
              <button
                className="page-link"
                onClick={() => paginate(currentPage + 1)}
              >
                {currentPage + 1}
              </button>
            </li>
          )}

          {currentPage < totalPages - 2 && (
            <li className="page-item">
              <span className="page-link">...</span>
            </li>
          )}

          {totalPages > 1 && (
            <li
              className={`page-item ${
                currentPage === totalPages ? "active" : ""
              }`}
            >
              <button
                className="page-link"
                onClick={() => paginate(totalPages)}
              >
                {totalPages}
              </button>
            </li>
          )}

          {currentPage < totalPages && (
            <li className="page-item">
              <button
                className="page-link"
                onClick={() => paginate(currentPage + 1)}
              >
                Next
              </button>
            </li>
          )}
        </ul>
      </nav>
    </div>
  );
};

export default Pagination;
